import { TableUIProvider } from "../../contexts/TableUIContext";
import IncomeExpenses from "./IncomeExpenses";

export default function IncomeExpensesWrapper() {
    return (
        <TableUIProvider>
            <IncomeExpenses />
        </TableUIProvider>
    );
}

